export default __webpack_public_path__ + "static/media/image5.7dec67b3.jpeg";